export default __webpack_public_path__ + "static/media/about.3c5e19b7.jpg";